/*
 * Copyright 2026 Sony Corporation
 */

import { createContext, useContext } from 'react';

import type { AppConfig } from '../config';
import type { ApiClient } from '../services/api-client';
import type { AuthService, SignInResult } from '../services/cognito-user-management';

export interface AuthContextValue {
  config: AppConfig;
  api: ApiClient;
  auth: AuthService;
  email: string | undefined;
  signedIn: boolean;
  signIn: (email: string, password: string) => Promise<SignInResult>;
  /** Called by the login page once a challenge resolves into a session. */
  confirmSignedIn: () => void;
  signOut: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const useAuth = (): AuthContextValue => {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error('useAuth must be used inside AuthProvider');
  }
  return value;
};
